import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { confirmPasswordReset } from '../../api/auth.api';
import { PasswordResetForm, TokenValidationLoading, TokenValidationError, AuthLayout } from '../../components/auth';
import LOGO from '../../assets/LOGO (2).png';

const ResetPassword = () => {
  const [isValidToken, setIsValidToken] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const uid = searchParams.get('uid');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!uid || !token) {
      setIsValidToken(false);
      toast.error('Lien de réinitialisation invalide.');
    } else {
      setIsValidToken(true);
    }
  }, [uid, token]);

  const handleSubmit = async ({ newPassword, confirmPassword }) => {
    if (newPassword !== confirmPassword) {
      toast.error('Les mots de passe ne correspondent pas.');
      return;
    }

    if (newPassword.length < 8) {
      toast.error('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }

    setIsLoading(true);

    try {
      await confirmPasswordReset(uid, token, newPassword);
      toast.success('Mot de passe réinitialisé avec succès !');
      setTimeout(() => {
        navigate('/');
      }, 2000);
    } catch (error) {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          toast.error(data?.new_password?.[0] || data?.token?.[0] || data?.uid?.[0] || 'Données invalides.');
        } else if (status === 404) {
          toast.error('Utilisateur non trouvé.');
        } else {
          toast.error(data?.detail || `Erreur (${status}). Veuillez réessayer.`);
        }
      } else if (error.request) {
        toast.error('Le serveur ne répond pas. Vérifie ta connexion réseau.');
      } else {
        toast.error('Erreur de configuration de la requête.');
      }
    } finally {
      setIsLoading(false);
    }
  };

  if (isValidToken === null) {
    return <TokenValidationLoading />;
  }

  if (isValidToken === false) {
    return <TokenValidationError onRetry={() => navigate('/mot-de-passe-oublie')} />;
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8">
        <div className="text-center mb-8">
          <img src={LOGO} alt="logo-easy-survey" className="mx-auto mb-6 h-20 w-auto" />
          <h2 className="text-2xl font-bold text-gray-800">Réinitialiser le mot de passe</h2>
          <p className="mt-2 text-gray-600">Entrez votre nouveau mot de passe ci-dessous.</p>
        </div>

        <PasswordResetForm onSubmit={handleSubmit} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default ResetPassword;
